import { FlowFormButton } from '../Buttons/FlowButtons/FlowFormButton'
import { RunFlowNodeButton } from '../Buttons/FlowButtons/RunFlowNodeButton'
import { LinkButton } from '../Buttons/Link'
import { ReactionButton } from '../Buttons/Reaction'
import { ShareButton } from '../Buttons/Share'
import { TextButton } from '../Buttons/TextButton'
import { TriggerCallButton } from '../Buttons/TriggerCall'
import { UserPropRedirectButton } from '../Buttons/UserPropRedirect'
import { BaseButton, ButtonTypes } from '../Buttons/types'

export default class MessageEditorModelButtonsFactory {
  static ModelsFactories: Array<{name: ButtonTypes | string, value: typeof BaseButton}> = [
    { name: ButtonTypes.Text, value: TextButton },
    { name: ButtonTypes.Link, value: LinkButton },
    { name: ButtonTypes.Share, value: ShareButton },
    { name: ButtonTypes.RunFlowNode, value: RunFlowNodeButton },
    { name: ButtonTypes.TriggerCall, value: TriggerCallButton },
    { name: ButtonTypes.UserPropRedirect, value: UserPropRedirectButton },
    { name: ButtonTypes.FlowFormButton, value: FlowFormButton },
    { name: ButtonTypes.Reaction, value: ReactionButton },
    { name: ButtonTypes.PalmsReaction, value: ReactionButton },
    { name: ButtonTypes.FingerUpReaction, value: ReactionButton },
    { name: ButtonTypes.FingerDownReaction, value: ReactionButton },
  ]

  static SetModelFactory(name: string, value: typeof BaseButton): void {
    this.ModelsFactories.push({ name, value })
  }
}
